var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"tabs"},[_c('span',{class:{active:_vm.show=='test'},on:{"click":function($event){return _vm.change('test')}}},[_vm._v("实验流程")]),_c('span',{class:{active:_vm.show=='fz'},on:{"click":function($event){return _vm.change('fz')}}},[_vm._v("仿真环境")])]),(_vm.show=='test')?_c('test-list'):_c('fz-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }